import { allPersonStates } from '../../status-transition-rules/person-transitions';
import TableFilter from '../table-models/TableFilter';

export const defaultParticipantsFilters: TableFilter[] = [
    { field: 'name', label: 'Name', value: '' },
    { field: 'email', label: 'Email', value: '' },
    { field: 'state', label: 'State', value: '', availableStates: allPersonStates },
];
